import { Stack, Switch, Typography } from "@mui/material";

interface TextSwitchProps {
  onSwitch: () => void;
  text: string;
  isEnabled?: boolean;
}

const TextSwitch = ({ isEnabled, onSwitch, text }: TextSwitchProps) => {
  return (
    <Stack flexDirection={"row"} alignItems={"center"}>
      <Typography sx={{ fontWeight: "400" }}>{text}</Typography>
      <Switch checked={isEnabled} onChange={onSwitch} />
    </Stack>
  );
};

export default TextSwitch;
